import { ReactNode } from "react";
import { DatesProvider } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { toDayjsLocale } from "@constants/languages";

export default function LocalizedDatesProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation(undefined, { useSuspense: false });
  return (
    <DatesProvider settings={{ locale: toDayjsLocale(i18n.language) }}>{children}</DatesProvider>
  );
}
